import { render, staticRenderFns } from "./VirtualAssistant.vue?vue&type=template&id=34bc6b2c&scoped=true&"
import script from "./VirtualAssistant.vue?vue&type=script&lang=js&"
export * from "./VirtualAssistant.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAssistant.vue?vue&type=style&index=0&id=34bc6b2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bc6b2c",
  null
  
)

export default component.exports